<template>
    <span>
        <a
            :style="!guest.status && 'padding-left: 33px'"
            :href="inquiryUrl"
        >
            <span
                v-html="
                    guest.status
                        ? renderGuestStatusIcon(guest.status)
                        : ''
                "
            >
            </span>
            {{ guest.displayName }}
        </a>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import { renderGuestStatusIcon } from '../helpers';

export default {
    computed: {
        inquiryUrl() {
            return this.guest.conversationLink;
        }
    },
    data() {
        return {
            guest: {
                id: null,
                status: null,
                displayName: null,
                inquiryId: null,
                conversationLink: null,
            },
        };
    },
    mounted() {
        this.guest = this.params.getGuest(this.params);
    },
    methods: {
        renderGuestStatusIcon: renderGuestStatusIcon,
    },
};
</script>

<style>
.dashboard-guest-status-icon {
    width: 24px;
    height: 23px;
    margin-right: 0.5rem;
}
</style>

